import MenuSection from "../../components/Menu/MenuSection";
import React from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { BrandUtils } from "../../utils/brandUtils";
import LoyaltyIndication from "../../components/LoyaltyIndicator/LoyaltyIndicatorBox";
import { loadLoyaltySection } from "./loader";
import { PageContextUtils } from "../../utils";

const Loyalty = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const sectionClassName = BrandUtils.isPokerClient()
    ? "loyaltySection"
    : "loyaltySectionHidden";
  let loyaltySection;
  if (Number.isNaN(Number(brandId))) {
    loyaltySection = null;
  } else {
    const { name } = PageContextUtils.getClientProviderData();
    const LoyaltySection = loadLoyaltySection(brandId, name);
    loyaltySection = <LoyaltySection />;
  }

  return (
    <MenuSection className={sectionClassName}>
      {isMobile && isAuthenticated && BrandUtils.isPokerClient() && (
        <LoyaltyIndication />
      )}
      {loyaltySection}
    </MenuSection>
  );
};

export default React.memo(Loyalty);
